import { get } from "lodash";
import { takeEvery } from "redux-saga/effects";
import {
  fetchOrganizationResponses,
  fetchOrganizationResponsesStart,
  fetchOrganizationResponsesSuccess,
  fetchOrganizationResponsesFailure,
} from "@/store/slices/organizationResponses";
import { fetcherForSagas } from "@/store/fetcherForSagas";
import { requestOrganizationResponses } from "@/features/assessments/api/requests";

function* organization_responses() {
  yield takeEvery(
    fetchOrganizationResponses,
    fetcherForSagas({
      start: fetchOrganizationResponsesStart,
      success: fetchOrganizationResponsesSuccess,
      failure: fetchOrganizationResponsesFailure,
      request: ({ payload }: any) => {
        const orgId = Number(payload.organization_id);
        const params: Record<string, any> = {};

        // Filter payload to the params we'll allow to be sent from here.
        params.criterion_id = get(payload, "criterion_id", "");
        params.program_id = get(payload, "program_id", "");
        params.set_id = get(payload, "set_id", "");

        // Hardcode pagination values (no need to support more flexibility).
        params.page = 1;
        params.per_page = 2000;

        return requestOrganizationResponses(orgId, params);
      },
    })
  );
}

export default organization_responses;
